import {
  GET_PATIENTS_REQUEST,
  GET_PATIENTS_SUCCESS,
  GET_PATIENTS_FAIL,
  GET_PATIENTS_RESET,
  GET_ALL_PATIENTS_REQUEST,
  GET_ALL_PATIENTS_SUCCESS,
  GET_ALL_PATIENTS_FAIL,
  GET_ALL_PATIENTS_RESET,
  CREATE_PATIENT_REQUEST,
  CREATE_PATIENT_SUCCESS,
  CREATE_PATIENT_FAIL,
  CREATE_PATIENT_RESET,
  DELETE_PATIENT_REQUEST,
  DELETE_PATIENT_SUCCESS,
  DELETE_PATIENT_FAIL,
  DELETE_PATIENT_RESET,
  GET_PATIENT_DETAILS_REQUEST,
  GET_PATIENT_DETAILS_SUCCESS,
  GET_PATIENT_DETAILS_FAIL,
  GET_PATIENT_DETAILS_RESET,
  UPDATE_PATIENT_REQUEST,
  UPDATE_PATIENT_SUCCESS,
  UPDATE_PATIENT_FAIL,
  UPDATE_PATIENT_RESET,
  GET_PATIENT_ACTIVITY_LOG_REQUEST,
  GET_PATIENT_ACTIVITY_LOG_SUCCESS,
  GET_PATIENT_ACTIVITY_LOG_FAIL,
  GET_PATIENT_ACTIVITY_LOG_RESET,
  GET_PATIENT_TREATMENT_PLANS_REQUEST,
  GET_PATIENT_TREATMENT_PLANS_SUCCESS,
  GET_PATIENT_TREATMENT_PLANS_FAIL,
  GET_PATIENT_TREATMENT_PLANS_RESET,
  PATIENT_ADDRESS_STATES_REQUEST,
  PATIENT_ADDRESS_STATES_SUCCESS,
  PATIENT_ADDRESS_STATES_FAIL,
  PATIENT_ADDRESS_STATES_RESET,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL,
  PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_RESET,
  PATIENT_VERIFY_PORTAL_PIN_REQUEST,
  PATIENT_VERIFY_PORTAL_PIN_SUCCESS,
  PATIENT_VERIFY_PORTAL_PIN_FAIL,
  PATIENT_VERIFY_PORTAL_PIN_RESET,
  PATIENT_REFRESH_PORTAL_TOKEN_REQUEST,
  PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS,
  PATIENT_REFRESH_PORTAL_TOKEN_FAIL,
  PATIENT_REFRESH_PORTAL_TOKEN_RESET,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL,
  PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_RESET,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL,
  PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_RESET,
  PATIENT_PORTAL_APPROVE_PLAN_REQUEST,
  PATIENT_PORTAL_APPROVE_PLAN_SUCCESS,
  PATIENT_PORTAL_APPROVE_PLAN_FAIL,
  PATIENT_PORTAL_APPROVE_PLAN_RESET,
  PATIENT_PORTAL_CANCEL_PLAN_REQUEST,
  PATIENT_PORTAL_CANCEL_PLAN_SUCCESS,
  PATIENT_PORTAL_CANCEL_PLAN_FAIL,
  PATIENT_PORTAL_CANCEL_PLAN_RESET,
} from "../constants/patientConstants";

export const getPatientsReducer = (
  state = {
    loading: false, // Initialize loading as false
    patients: [],
    pages: 1, // Initialize pages to 1 to prevent undefined page numbers
    page: 1, // Initialize current page to 1 to prevent undefined page numbers,
    countsByStatus: {
      total: 0,
      new: 0,
      active: 0,
      inactive: 0,
      consulting: 0,
      planningTreatment: 0,
      cancelledTreatment: 0,
      completedTreatment: 0,
      ongoingTreatment: 0,
      approvedTreatment: 0,
    }, // Initialize countsByStatus with all fields set to 0
    countsByAgeGroup: {
      "0-12": 0,
      "13-25": 0,
      "26-40": 0,
      "41-60": 0,
      "61-150": 0,
    }, // Initialize countsByAgeGroup with all fields set to 0
    countsByGender: {
      male: 0,
      female: 0,
    },
    genderPercentages: {
      male: 0,
      female: 0,
      other: 0,
    },
    totalCount: 0, // Initialize totalCount to 0
    totalCountBasedOnFilter: 0, // Initialize totalCountBasedOnFilter to 0
  },
  action
) => {
  switch (action.type) {
    case GET_PATIENTS_REQUEST:
      return {
        ...state, // Preserve existing state to avoid data loss on request
        loading: true, // Set loading to true for UI to show loading indicators
      };
    case GET_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        patients: action.payload.patients,
        pages: action.payload.pages,
        page: action.payload.page,
        countsByStatus: action.payload.countsByStatus,
        countsByAgeGroup: action.payload.countsByAgeGroup,
        countsByGender: action.payload.countsByGender,
        genderPercentages: action.payload.genderPercentages,
        totalCount: action.payload.totalCount,
        totalCountBasedOnFilter: action.payload.totalCountBasedOnFilter,
      };
    case GET_PATIENTS_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case GET_PATIENTS_RESET:
      return {
        loading: false,
        patients: [],
        countsByStatus: {
          total: 0,
          new: 0,
          inactive: 0,
          planningTreatment: 0,
          cancelledTreatment: 0,
          completedTreatment: 0,
          ongoingTreatment: 0,
          approvedTreatment: 0,
        },
        countsByAgeGroup: {
          "0-12": 0,
          "13-25": 0,
          "26-40": 0,
          "41-60": 0,
          "61-150": 0,
        },
        countsByGender: {
          male: 0,
          female: 0,
        },
        genderPercentages: {
          male: 0,
          female: 0,
          other: 0,
        },
        totalCount: 0,
        totalCountBasedOnFilter: 0,
        pages: 1,
        page: 1,
      };

    default:
      return state;
  }
};

export const getAllPatientsReducer = (
  state = {
    loading: false, // Initialize loading state
    patients: [], // Store all patients here
  },
  action
) => {
  switch (action.type) {
    case GET_ALL_PATIENTS_REQUEST:
      return {
        ...state,
        loading: true, // Set loading to true when request starts
      };

    case GET_ALL_PATIENTS_SUCCESS:
      return {
        ...state,
        loading: false, // Set loading to false when request succeeds
        patients: action.payload, // Store all patients from payload
      };

    case GET_ALL_PATIENTS_FAIL:
      return {
        ...state,
        loading: false, // Set loading to false when request fails
        error: action.payload, // Store error message from payload
      };

    case GET_ALL_PATIENTS_RESET:
      return {
        loading: false,
        patients: [], // Reset to initial state
      };

    default:
      return state;
  }
};

export const createPatientReducer = (state = {}, action) => {
  switch (action.type) {
    case CREATE_PATIENT_REQUEST:
      return { loading: true };
    case CREATE_PATIENT_SUCCESS:
      return { loading: false, success: true, patient: action.payload };
    case CREATE_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case CREATE_PATIENT_RESET:
      return {};

    default:
      return state;
  }
};

export const deletePatientReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_PATIENT_REQUEST:
      return { loading: true };
    case DELETE_PATIENT_SUCCESS:
      return { loading: false, success: true };
    case DELETE_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case DELETE_PATIENT_RESET:
      return {};
    default:
      return state;
  }
};

export const getPatientDetailsReducer = (state = { patient: {} }, action) => {
  switch (action.type) {
    case GET_PATIENT_DETAILS_REQUEST:
      return { ...state, loading: true };
    case GET_PATIENT_DETAILS_SUCCESS:
      return { loading: false, patient: action.payload };
    case GET_PATIENT_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case GET_PATIENT_DETAILS_RESET:
      return { patient: {} };
    default:
      return state;
  }
};

export const updatePatientReducer = (state = { patient: {} }, action) => {
  switch (action.type) {
    case UPDATE_PATIENT_REQUEST:
      return { loading: true };
    case UPDATE_PATIENT_SUCCESS:
      return { loading: false, success: true, patient: action.payload };
    case UPDATE_PATIENT_FAIL:
      return { loading: false, error: action.payload };
    case UPDATE_PATIENT_RESET:
      return { patient: {} };
    default:
      return state;
  }
};
export const getPatientActivityLogReducer = (state = { logs: [] }, action) => {
  switch (action.type) {
    case GET_PATIENT_ACTIVITY_LOG_REQUEST:
      return { ...state, loading: true };
    case GET_PATIENT_ACTIVITY_LOG_SUCCESS:
      return {
        loading: false,
        logs: action.payload.activityLog, // Replace logs, no appending
        pages: action.payload.pages,
        page: action.payload.page,
        totalLogs: action.payload.totalLogs, // Optional: Track total logs
      };
    case GET_PATIENT_ACTIVITY_LOG_FAIL:
      return { ...state, loading: false, error: action.payload };
    case GET_PATIENT_ACTIVITY_LOG_RESET:
      return { logs: [], loading: false, error: null }; // Reset logs when patient changes
    default:
      return state;
  }
};

export const getPatientTreatmentPlansReducer = (
  state = { treatmentPlans: [], totalPlans: 0, page: 1, pages: 1 },
  action
) => {
  switch (action.type) {
    case GET_PATIENT_TREATMENT_PLANS_REQUEST:
      return { ...state, loading: true };

    case GET_PATIENT_TREATMENT_PLANS_SUCCESS:
      return {
        loading: false,
        treatmentPlans: action.payload.treatmentPlans, // Store treatment plans from the action payload
        totalPlans: action.payload.totalPlans, // Total number of plans for pagination
        page: action.payload.page, // Current page number
        pages: action.payload.pages, // Total number of pages
      };

    case GET_PATIENT_TREATMENT_PLANS_FAIL:
      return { ...state, loading: false, error: action.payload };

    case GET_PATIENT_TREATMENT_PLANS_RESET:
      return { treatmentPlans: [], totalPlans: 0, page: 1, pages: 1 };

    default:
      return state;
  }
};

export const patientAddressStatesReducer = (
  state = { addressStates: [] },
  action
) => {
  switch (action.type) {
    case PATIENT_ADDRESS_STATES_REQUEST:
      return { loading: true, addressStates: [] };
    case PATIENT_ADDRESS_STATES_SUCCESS:
      return {
        loading: false,
        addressStates: action.payload,
      };
    case PATIENT_ADDRESS_STATES_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_ADDRESS_STATES_RESET:
      return { addressStates: [] };
    default:
      return state;
  }
};

export const getPatientPortalPublicDetailsReducer = (
  state = { patientPortalPublicDetails: {} },
  action
) => {
  switch (action.type) {
    case PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_REQUEST:
      return { loading: true, patient: {} };
    case PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_SUCCESS:
      return {
        loading: false,
        patientPortalPublicDetails: action.payload,
      };
    case PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_GET_PATIENT_PORTAL_PUBLIC_DETAILS_RESET:
      return { patientPortalPublicDetails: {} };
    default:
      return state;
  }
};

export const patientPortalVerifyPinReducer = (
  state = { patientToken: null },
  action
) => {
  switch (action.type) {
    case PATIENT_VERIFY_PORTAL_PIN_REQUEST:
      return { loading: true };
    case PATIENT_VERIFY_PORTAL_PIN_SUCCESS:
      return {
        loading: false,
        success: true,
        patientToken: action.payload, // Stores token and patient details
      };
    case PATIENT_VERIFY_PORTAL_PIN_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_VERIFY_PORTAL_PIN_RESET:
      return { patientToken: null };
    default:
      return state;
  }
};

export const patientRefreshPortalTokenReducer = (
  state = { patientToken: null },
  action
) => {
  switch (action.type) {
    case PATIENT_REFRESH_PORTAL_TOKEN_REQUEST:
      return { loading: true };
    case PATIENT_REFRESH_PORTAL_TOKEN_SUCCESS:
      return {
        loading: false,
        success: true,
        patientToken: action.payload,
      };
    case PATIENT_REFRESH_PORTAL_TOKEN_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_REFRESH_PORTAL_TOKEN_RESET:
      return { patientToken: null };
    default:
      return state;
  }
};

export const getPatientPortalTreatmentPlansReducer = (
  state = { treatmentPlans: [] },
  action
) => {
  switch (action.type) {
    case PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_REQUEST:
      return { loading: true, treatmentPlans: [] };
    case PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_SUCCESS:
      return {
        loading: false,
        treatmentPlans: action.payload,
      };
    case PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_GET_PATIENT_PORTAL_TREATMENT_PLANS_RESET:
      return { treatmentPlans: [] };
    default:
      return state;
  }
};

export const patientDownloadPlanPdfReducer = (
  state = { loading: false },
  action
) => {
  switch (action.type) {
    case PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_REQUEST:
      return { loading: true };
    case PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_SUCCESS:
      return { loading: false, success: true };
    case PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_PORTAL_DOWNLOAD_PLAN_PDF_RESET:
      return { loading: false };
    default:
      return state;
  }
};

export const patientApprovePlanReducer = (
  state = { success: false },
  action
) => {
  switch (action.type) {
    case PATIENT_PORTAL_APPROVE_PLAN_REQUEST:
      return { loading: true };
    case PATIENT_PORTAL_APPROVE_PLAN_SUCCESS:
      return {
        loading: false,
        success: true,
        approvedPlan: action.payload.treatmentPlan,
      };
    case PATIENT_PORTAL_APPROVE_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_PORTAL_APPROVE_PLAN_RESET:
      return { success: false };
    default:
      return state;
  }
};

export const patientCancelPlanReducer = (
  state = { loading: false, success: false },
  action
) => {
  switch (action.type) {
    case PATIENT_PORTAL_CANCEL_PLAN_REQUEST:
      return { loading: true };
    case PATIENT_PORTAL_CANCEL_PLAN_SUCCESS:
      return {
        loading: false,
        success: true,
        cancelledPlan: action.payload,
      };
    case PATIENT_PORTAL_CANCEL_PLAN_FAIL:
      return { loading: false, error: action.payload };
    case PATIENT_PORTAL_CANCEL_PLAN_RESET:
      return { loading: false, success: false };
    default:
      return state;
  }
};
